import useSWR from "swr";

export const useFetchKuchikomyuQrCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: KuchikomyuQrCount, error, isLoading } = useSWR<number>(`kuchikomyu/qr/count/?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`)
  return { KuchikomyuQrCount, isLoading, error };
};

